import {URL_API,REPAIRMODEL_REQUEST,REPAIRMODEL_SUCCESS,REPAIRMODEL_FAILURE,REPAIRMODEL_CLEAR} from "../constants";
import {RSAA} from "redux-api-middleware";
import {withAuth} from "../reducers";

export const listRepair = (id) => ({
  [RSAA]: {
      endpoint: `${URL_API}/equip-model/${id}/`,
      method: 'GET',
      headers: withAuth({ 'Content-Type': 'application/json' }),
      types: [
        REPAIRMODEL_REQUEST, REPAIRMODEL_SUCCESS, REPAIRMODEL_FAILURE
      ]
  }
})

export function listRepairModel (items){
    return {
        type: REPAIRMODEL_SUCCESS,
        items
    }
}

export function clearRepairModel() {
    return {
        type:REPAIRMODEL_CLEAR
    }
}


// WEBPACK FOOTER //
// ./src/actions/repairModel.js